$(document).ready(function(){
  var src = $(".select.featured-collection-sort select").attr("coll-url");
  $(".select.featured-collection-sort select").on("change", function(){
    var val = $(this).find("option:selected").val();
    console.log(val);
    var page = $(this).parents(".color-background-1.isolate.gradient").find("ul.pagination__list.list-unstyled .pagination__item--current").text();
    var colsrc = src+"?page="+page+"&sort_by="+val;
    console.log(colsrc);
                $.ajax({
                  type: "GET",
                  url: colsrc,
                  dataType: 'html',

                  success: function(data) 
                  {
                    var minicartdata=$(data).find('.important-for-sort').html();
                    $(".sort--work--here ul.grid.product-grid").html(minicartdata);
                    //console.log(minicartdata);
                  }
                });
  })
  var activepage = $(".sort--work--here").find("ul.pagination__list.list-unstyled a.pagination__item.pagination__item--current").text();
  console.log(activepage);
  var colsrc = src+"?page="+activepage;
  $.ajax({
                  type: "GET",
                  url: colsrc,
                  dataType: 'html',

                  success: function(data) 
                  {
                    var minicartdata=$(data).find('.important-for-sort').html();
                    //var pagination = $(data).find('.important-for-sort .pagination-results').html();
                    $(".sort--work--here ul.grid.product-grid").html(minicartdata);
                    //$(".sort--work--here .pagination-results").html(pagination);
                    //console.log(minicartdata);
                  }
                });
  // $(".sort--work--here").find("ul.pagination__list.list-unstyled li a").on("click", function(e){
    
  //   var val = $(this).find(".select.featured-collection-sort select option:selected").val();
  //   e.preventDefault();
  //   e.stopPropagation();
  //   $(this).addClass("pagination__item--current light");
  //   $(this).parents("li").nextAll("li").find("a").removeClass("pagination__item--current light");
  //   $(this).parents("li").prevAll("li").find("a").removeClass("pagination__item--current light");
  //   var page = $(this).attr("href");
  //   if ( val != undefined  )
  //   {
  //     var colsrc = src+page+"&sort_by="+val;
  //   }
  //   else
  //   {
  //     var colsrc = src+page;
  //   }
  //   console.log(colsrc);
  //               $.ajax({
  //                 type: "GET",
  //                 url: colsrc,
  //                 dataType: 'html',

  //                 success: function(data) 
  //                 {
  //                   var minicartdata=$(data).find('.important-for-sort').html();
  //                   var pagination = $(data).find('.important-for-sort .pagination-results').html();
  //                   $(".sort--work--here ul.grid.product-grid").html(minicartdata);
  //                   $(".sort--work--here .pagination-results").html(pagination);
  //                   //console.log(minicartdata);
  //                 }
  //               });
  // })
})